import { render } from "./YourCourses.vue?vue&type=template&id=60d2e440&scoped=true"
import script from "./YourCourses.vue?vue&type=script&lang=js"
export * from "./YourCourses.vue?vue&type=script&lang=js"

import "./YourCourses.vue?vue&type=style&index=0&id=60d2e440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d2e440"]])

export default __exports__